import _default from './Breadcrumb';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/collections/Breadcrumb/index.js
// module id = 2689
// module chunks = 1